/**
 * Data Service — loads all dashboard data from /data/ JSON files
 */
const BASE = "/data";

async function fetchJSON(url) {
  const resp = await fetch(url);
  if (!resp.ok) throw new Error(`${resp.status}: ${url}`);
  return resp.json();
}

/** Latest pipeline run result */
export async function getPipelineData() {
  try {
    return await fetchJSON(`${BASE}/latest_pipeline.json`);
  } catch {
    return null;
  }
}

/** Pricing data (auto-extracted + manual fill) */
export async function getPricingData() {
  try {
    return await fetchJSON(`${BASE}/pricing_data.json`);
  } catch {
    return null;
  }
}

/** Competitor list from config */
export async function getCompetitors() {
  try {
    return await fetchJSON(`${BASE}/competitors.json`);
  } catch {
    return null;
  }
}

/** Alert history */
export async function getAlerts() {
  try {
    return await fetchJSON(`${BASE}/alerts.json`);
  } catch {
    return { alerts: [] };
  }
}

/** Data manifest */
export async function getManifest() {
  try {
    return await fetchJSON(`${BASE}/manifest.json`);
  } catch {
    return null;
  }
}

/** Human-friendly time */
export function timeAgo(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  const now = new Date();
  const sec = Math.floor((now - d) / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  return d.toLocaleDateString();
}

/** Format a data source freshness indicator */
export function Freshness({ dateStr, label }) {
  return (
    <span className="text-xs text-gray-400 inline-flex items-center gap-1">
      <span className={`w-1.5 h-1.5 rounded-full ${
        dateStr && (Date.now() - new Date(dateStr).getTime()) < 3600000
          ? "bg-green-400"
          : dateStr && (Date.now() - new Date(dateStr).getTime()) < 86400000
            ? "bg-yellow-400"
            : "bg-gray-300"
      }`} />
      {label}: {timeAgo(dateStr)}
    </span>
  );
}
